import React, { useState, useEffect, useCallback, useMemo } from "react";

import { Grid } from "@mui/material";
import {
    BreadCrumbs,
    Documents as TableDocuments,
    PageTitleWithToolTip,
} from "../Common";
import AddButton from "../Common/AddButton";

import Routes from "../../routes";
import UserInfo from "../../UserInfo";
import { Padding } from "@mui/icons-material";

const Documents = () => {
    const [modalOpen, setOpenModal] = useState(false);

    const filters = [
        {
            name: "All Users",
            property: "fileTypeName",
            value: "All Users"
        },
        {
            name: `All Users in ${UserInfo.instanceName}`,
            property: "fileTypeName",
            value: `All Users in ${UserInfo.instanceName}`
        },
        {
            name: "All Reseller",
            property: "fileTypeName",
            value: "All Reseller"
        },
        {
            name: "All Super Tenant Admins",
            property: "fileTypeName",
            value: "All Super Tenant Admins",
        },
        {
            name: "All Tenant Administrators",
            property: "fileTypeName",
            value: "All Tenant Administrators",
        },
        {
            name: "All Regional Administrators",
            property: "fileTypeName",
            value: "All Regional Administrators"
        },
        {
            name: "All Purchasing Administrators",
            property: "fileTypeName",
            value: "All Purchasing Administrators",
        },
        {
            name: "All Technician Managers",
            property: "fileTypeName",
            value: "All Technician Managers",
        },
        {
            name: "All Technicians",
            property: "fileTypeName",
            value: "All Technicians",
        },
        {
            name: "All Read-only users",
            property: "fileTypeName",
            value: "All Read-only users",
        }
    ];

    const AddButtonWithPermission = () => {

        const isSystemOwnerSuperTenantAdminOrTenantAdmin = (UserInfo.isSuperTenantAdmin() || UserInfo.isTenantAdministrator()) && UserInfo.isSystemOwner() && UserInfo.isNativeUser();
        const isServiceProviderTenantAdminOrTechnicianManager = (UserInfo.isTenantAdministrator() || UserInfo.isTechnicianManager()) && UserInfo.isServiceProvider() && UserInfo.isNativeUser();
        const isSystemAdministrator = UserInfo.isSystemAdministrator();

        if (isSystemAdministrator || isSystemOwnerSuperTenantAdminOrTenantAdmin || isServiceProviderTenantAdminOrTechnicianManager) {
            return <AddButton text={"Add Document"} onClick={() => setOpenModal(true)} />
        }

        return null;
    }

    const fetchAccountDocuments = useCallback(async () => {
        const response = await fetch(Routes.Account.UserTableFilters());
        const data = await response.json();
        console.log({
            data
        });
    }, []);

    useEffect(() => {
        fetchAccountDocuments();
    }, [fetchAccountDocuments])

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: "Account Details", to: `/Account` },
                    { text: "Your Documents" },
                ]}
            />
            <Grid container direction="row" alignItems="center">
                <Grid item xs={6} md={6} lg={6}>
                    <PageTitleWithToolTip
                        pageTitle={"Your Documents"}
                        toolTipText="Add your documents to the account and view your existing documents."
                    />
                </Grid>
                <Grid item xs={6} md={6} lg={6} align="right">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            flexDirection: "row",
                            gap: "15px",
                        }}
                    >
                        <div
                            style={{
                                position: "relative",
                            }}
                        >
                            <AddButtonWithPermission />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} lg={12} mb={1} pt={2}>
                    <TableDocuments
                        id="0"
                        fileType={0}
                        showTableOnly={true}
                        filters={filters}
                        openModal={modalOpen}
                        closeModal={() => setOpenModal(false)}
                        fromPage={"Account"}
                        hideActions
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default Documents;